import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { logout } from "../../features/user";
import axios from "axios";
import { API_URL, API_OK, STATUS_BLOCKED, API_EXCEPTION, DEFAULT_ERROR_TEXT, ALL, CALL_TYPE_ALL, CALL_TYPE_IN, CALL_TYPE_OUT, STATUS_OPEN} from '../../Constants';
import {Dialog} from '@mui/material';
import '../../styles.css';
import cookie from "js-cookie";
import { useTranslation } from 'react-i18next';
import { useDispatch } from "react-redux";
import { showErrorDialog } from "../../features/errorDialog";
import {handleApiErrorMessage, allowedBlockStatuses, allowedBlockCallTypes} from "../../Helper";
import CategoryDesktop from './Desktop/Category';
import CategoryMobile from './Mobile/Category';
import BlockNumberNotes from '../BlockNumberNotes';

export const IMPORT_HOVER_UPLOAD = "upload";
export const IMPORT_HOVER_DOWNLOAD = "download";

export default function Category(props) {
  const { t } = useTranslation();
  const [deleteDialogIsOpen, setDeleteDialogIsOpen] = useState(false);

  const [expandedRowIds, setExpandedRowIds] = useState([]);
  const [editBlockValues, setEditBlockValues] = useState({});

  const [isAddFormVisible, setIsAddFormVisible] = useState(false);
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [editDialogRow, setEditDialogRow] = useState(null);

  const initalSelectedCategoryValue = {
    id: null,
    name: null,
    note: null,
    public: 1,
    privacy_level: 0,
    isOwner: 1,
    myJoin: 0,
    valid: 0,
    active_setting: 0
  };
  const [selectedCategory, setSelectedCategory] = useState(initalSelectedCategoryValue);

  const initialSearchInput = {
    number : props.initialNumberSearch || "",
    active: ALL,
    call_type: ALL,
    status: ALL
  };
  const [searchInput, setSearchInput] = useState(initialSearchInput);
  // true until the first block-list fetch resolves — keeps the spinner up so the grid
  // never flashes "no records found" before the data arrives.
  const [initialLoad, setInitialLoad] = useState(true);

  // ברירות מחדל להוספה נבחרות מתוך המותר במדיניות החסימה של הקהילה (אחרת ה-select מציג ערך שאינו קיים באפשרויות).
  const initialAddValue = {
    number : "",
    active: "1",
    call_type: allowedBlockCallTypes().includes(CALL_TYPE_ALL) ? CALL_TYPE_ALL : allowedBlockCallTypes()[0],
    status: allowedBlockStatuses().includes(STATUS_OPEN) ? STATUS_OPEN : allowedBlockStatuses()[0],
    note: "",
    actionNote: ""
  };
  const [addValue, setAddValue] = useState(initialAddValue);
  // הערת ביצוע אופציונלית למחיקה (נרשמת ב-block_list_log.action_note)
  const [deleteActionNote, setDeleteActionNote] = useState("");
  const [lineNumbersToHighlight, setLineNumbersToHighlight] = useState([]);

  const [selectionIds, setSelectionIds] = useState([]);
  const [singleRowIdToDelete, setSingleRowIdToDelete] = useState(null);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [pageSize, setPageSize] = useState(1000);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if(props.loading){
      return () => {};
    }

    if(props.hasOwnProperty("category") 
      && props.category.hasOwnProperty("id")
      && Number.isInteger(props.category.id)){
        const selectedCategoryValueFromProps = {
          id: props.category.id,
          name: props.category.name,
          note: props.category.note,
          public: props.category.public,
          isOwner: props.category.isOwner,
          myJoin: props.category.myJoin,
          valid: props.category.valid,
          privacy_level: props.category.privacy_level,
          active_setting: props.category.active_setting
        };
    
        setSelectedCategory(selectedCategoryValueFromProps);
    }
  }, []);

  useEffect(() => {
    if(props.loading){
      return () => {};
    }
    if(!Number.isInteger(selectedCategory.id)){
      return () => {};
    }
    const requestSource = refreshBlockedData(); 
    return () => {
      requestSource.cancel();
    };
  }, [page, pageSize]);

  useEffect(() => {
    if(!Number.isInteger(selectedCategory.id)){
      return () => {};
    }
    const requestSource = refreshBlockedData(); 
    return () => {
      requestSource.cancel();
    };
  }, [selectedCategory.id]);

  useEffect(() => {
    removeNonExistingSelectionIds();
  }, [rows]);

  const removeNonExistingSelectionIds = () => {
    let newSelectionIds = [];
    for(let index=0; index<rows.length; index++){
      if(selectionIds.includes(rows[index].id)){
        newSelectionIds.push(rows[index].id);
      }
    }
    setSelectionIds(newSelectionIds);
  }

  const refreshBlockedData = (pageToStart = null, overrides = null) => {
    if(pageToStart === null){
      pageToStart = page;
    }
    // use explicit filters when provided (e.g. right after clearing), otherwise current state
    const filters = overrides || searchInput;
    let errorMessage = t(DEFAULT_ERROR_TEXT);
    props.setLoading(true);

    let  headers = {
      token: cookie.get('token')
    }

    let apiUrl = API_URL + '/getBlockList';
    if(Number.isInteger(selectedCategory.id)
        && (selectedCategory.id > 0)){
          apiUrl = API_URL + '/categories/'+selectedCategory.id+'/getBlockList';
    }

    const requestSource = axios.CancelToken.source();
    headers.cancelToken = requestSource.token;

    // is the list filtered? if not, we can take the total straight from the
    // category list's active_setting (fast) instead of a heavy server count.
    const isFiltered = filters.number !== "" || filters.active !== ALL
      || filters.status !== ALL || filters.call_type !== ALL;
    const countFromList = Number(selectedCategory.active_setting);

    axios.post(
      apiUrl,
      {
        searchStr:filters.number,
        active: filters.active === ALL ? ALL : Number(filters.active),
        status: filters.status,
        call_type: filters.call_type,
        start: pageToStart*pageSize,
        limit: pageSize          // one page of 1000
      },
      {headers})
    .then(
      ({ data }) => {
        if(data.hasOwnProperty("responseStatus") && (data["responseStatus"] === API_OK && data.hasOwnProperty("results"))){
          setRows(data.results);
          if(!isFiltered && Number.isFinite(countFromList) && countFromList > 0){
            setRowCount(countFromList);
          }else{
            setRowCount(data.hasOwnProperty("totalBlocks") ? data.totalBlocks : data.results.length);
          }
          setInitialLoad(false);
          props.setLoading(false);
        }else{
          if((data.responseStatus === API_EXCEPTION) && (data.hasOwnProperty("message"))){
            errorMessage = data["message"];
          }
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
          setInitialLoad(false);
          props.setLoading(false);
        }
      }).catch((error) => {
        if(!axios.isCancel(error)){
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
          setInitialLoad(false);
          props.setLoading(false);
        }
    });

    return requestSource;
  };

  const toggleExpandRow = (rowId) => {
    if(expandedRowIds.includes(rowId)){
      let newExpandedRowIds = [...expandedRowIds];
      newExpandedRowIds.splice(newExpandedRowIds.indexOf(rowId), 1);
      setExpandedRowIds(newExpandedRowIds);
    }else{
      setExpandedRowIds([...expandedRowIds, rowId]);
    }
  }

  const handleDeleteRow = (cellValues) => {
    setSingleRowIdToDelete(cellValues.id);
    setDeleteDialogIsOpen(true);
  };
  
  const handleDeleteRowsSubmit = async () => {
    let errorMessage = t(DEFAULT_ERROR_TEXT);

    let rowIdsToDelete = [];
    if(selectionIds.length > 0){
      rowIdsToDelete = selectionIds;
    }else if(singleRowIdToDelete !== null){
      rowIdsToDelete = [singleRowIdToDelete];
    }

    if(rowIdsToDelete.length === 0){
      alert(t('No lines selected'));
      return;
    }else{
      let nonRemovedRows = rows.filter((row) => (!rowIdsToDelete.includes(row.id)));
      if(nonRemovedRows.length === rows.length){
        alert(t('No lines selected'));
        return;
      }
    }
    
    props.setLoading(true);

    let  headers = {
      token: cookie.get('token')
    }
    
    const data = {
      blockIds: rowIdsToDelete,
      actionNote: deleteActionNote
    };

    let apiUrl = API_URL + '/deleteBlocks';
    if(Number.isInteger(selectedCategory.id)
        && (selectedCategory.id > 0)){
          apiUrl = API_URL + '/categories/'+selectedCategory.id+'/deleteBlocks';
    }

    axios.post(apiUrl, data, {headers})
    .then(
        (responseData) => {
        if(responseData.data.hasOwnProperty('responseStatus') && responseData.data.responseStatus === API_OK){
          refreshBlockedData();
          setSelectionIds([]);
          setDeleteActionNote("");
        }else{
          if(responseData.data.responseStatus === API_EXCEPTION && responseData.data.hasOwnProperty("message")){
            errorMessage = responseData.data["message"];
          }
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        }
        props.setLoading(false);
      }).catch((error) => {
        handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);

        props.setLoading(false);
    });
  };

  const addLinesData = (linesDataToAdd) => {
    let errorMessage = t(DEFAULT_ERROR_TEXT);

    let  headers = {
      token: cookie.get('token')
    }

    let apiUrl = API_URL + '/addBlockList';
    if(Number.isInteger(selectedCategory.id)
        && (selectedCategory.id > 0)){
          apiUrl = API_URL + '/categories/'+selectedCategory.id+'/addBlockList';
    }

    axios.post(apiUrl, linesDataToAdd, {headers})
    .then(
      async (responseData) => {
        if(responseData.data.hasOwnProperty('responseStatus') && responseData.data.responseStatus === API_OK){
          await refreshBlockedData();
          setLineNumbersToHighlight([addValue.number]);
          setTimeout(() => {
            setLineNumbersToHighlight([]);
          }, 1000);
          props.setLoading(false);
        }else{
          if((responseData.data.responseStatus === API_EXCEPTION) && (responseData.data.hasOwnProperty("message"))){
            errorMessage = responseData.data["message"];
          }
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
          props.setLoading(false);
        }
      }).catch((error) => {
        handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        props.setLoading(false);
    });
  };

  const handleAddLineSubmit = () => {
    if(addValue.number === ""){
      return;
    }
    props.setLoading(true);

    // הערת הביצוע (actionNote) נשלחת ברמת הפעולה, לא כחלק מפריט המספר.
    const { actionNote, ...numberItem } = addValue;
    addLinesData({"numbers": [numberItem], actionNote});
    setIsAddFormVisible(false);
    setAddDialogOpen(false);
  }

  const handleAddClick = () => {
    setAddValue(initialAddValue);
    setAddDialogOpen(true);
  }

  const handleEditClick = (row) => {
    setEditBlockValues({ ...editBlockValues, [row.id]: { ...row } });
    setEditDialogRow(row);
  }

  const onImportRows = () => {
    document.getElementById("import_file").click();
  }

  const onImportRowsSubmit = (file) => {
    let errorMessage = t(DEFAULT_ERROR_TEXT);

    const data = new FormData();
    data.append('file', file);
    
    let  headers = {
      token: cookie.get('token')
    }

    props.setLoading(true);

    let apiUrl = API_URL + '/importExcel';
    if(Number.isInteger(selectedCategory.id)
        && (selectedCategory.id > 0)){
          apiUrl = API_URL + '/categories/'+selectedCategory.id+'/importExcel';
    }

    axios.post(apiUrl, data, {headers})
    .then(
      async (responseData) => {
        if(responseData.data.hasOwnProperty('responseStatus') && responseData.data.responseStatus === API_OK){
          await refreshBlockedData();
          props.setLoading(false);
        }else{
          if((responseData.data.responseStatus === API_EXCEPTION) && (responseData.data.hasOwnProperty("message"))){
            errorMessage = responseData.data["message"];
          }
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
          props.setLoading(false);
        }
      }).catch((error) => {
        handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        props.setLoading(false);
    });
  }

  const handleEditLineSubmit = (blockId) => {
    let errorMessage = t(DEFAULT_ERROR_TEXT);

    props.setLoading(true);

    let  headers = {
      token: cookie.get('token')
    }

    const data = {
      blockId: blockId,
      newData: {
        note: editBlockValues[blockId].note,
        active: editBlockValues[blockId].active,
        call_type: editBlockValues[blockId].call_type,
        status: editBlockValues[blockId].status
      },
      // הערת הביצוע (actionNote) נרשמת ב-block_list_log.action_note
      actionNote: editBlockValues[blockId].actionNote
    };

    let apiUrl = API_URL + '/editBlock';
    if(Number.isInteger(selectedCategory.id)
        && (selectedCategory.id > 0)){
          apiUrl = API_URL + '/categories/'+selectedCategory.id+'/editBlock';
    }

    axios.post(apiUrl, data, {headers})
    .then(
      async (responseData) => {
        if(responseData.data.hasOwnProperty('responseStatus') && responseData.data.responseStatus === API_OK){
          await refreshBlockedData();
          setEditDialogRow(null);
        }else{
          if(responseData.data.responseStatus === API_EXCEPTION && responseData.data.hasOwnProperty("message")){
            errorMessage = responseData.data["message"];
          }
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        }
        props.setLoading(false);
      }).catch((error) => {
        handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        props.setLoading(false);
    });
  }

  const changeSearchFilters = (newValue, fieldName) => {
    let newSearchInput = {
      number : searchInput.number,
      active: searchInput.active,
      call_type: searchInput.call_type,
      status: searchInput.status
    };
    newSearchInput[fieldName] = newValue;
    setSearchInput(newSearchInput);
  };

  const handleSearchSubmit = (overrides = null) => {
    setPage(0);                         // reset to the first page for a fresh search
    refreshBlockedData(0, overrides);
  };

  const handleChangeEditValue = (newValue, changedField, cellValues) => {
    if(newValue === cellValues[changedField]){
      return;
    }
    const newField = {[changedField] : newValue};
    const newValues = {...cellValues, ...newField};
    setEditBlockValues({...editBlockValues, [cellValues.id] : newValues});
  }

  const isValidValue = (value, type='') => {
    if(type === "number"){
      if(!/^[0-9*+]*$/.test(value)){
          return false;
      }
    }
    return true;
}

  return (  
    <>
    {(
      props.isDesktop ? 
      <CategoryDesktop 
      handleAddClick={handleAddClick}
      page={page}
      setPage={setPage}
      rows={rows}
      setRows={setRows}
      rowCount={rowCount}
      setRowCount={setRowCount}
      pageSize={pageSize}
      setPageSize={setPageSize}
      handleEditLineSubmit={handleEditLineSubmit}
      searchInput={searchInput}
      changeSearchFilters={changeSearchFilters}
      handleChangeEditValue={handleChangeEditValue}
      handleSearchSubmit={handleSearchSubmit}
      selectedCategory={selectedCategory}
      handleDeleteRow={handleDeleteRow}
      onImportRows={onImportRows}
      toggleExpandRow={toggleExpandRow}
      handleEditClick={handleEditClick}
      lineNumbersToHighlight={lineNumbersToHighlight}
      editBlockValues={editBlockValues}
      setDeleteDialogIsOpen={setDeleteDialogIsOpen}
      loading={props.loading || initialLoad}
      setLoading={props.setLoading}
      selectionIds={selectionIds}
      setSelectionIds={setSelectionIds}
      expandedRowIds={expandedRowIds}
      setExpandedRowIds={setExpandedRowIds}
      viewCategoriesList={props.viewCategoriesList}
      isValidValue={isValidValue}
      addValue={addValue}
      setAddValue={setAddValue}
      handleAddLineSubmit={handleAddLineSubmit}
      isAddFormVisible={isAddFormVisible}
      setIsAddFormVisible={setIsAddFormVisible}
      /> :
      <CategoryMobile 
      handleAddClick={handleAddClick}
      page={page}
      setPage={setPage}
      rows={rows}
      setRows={setRows}
      rowCount={rowCount}
      setRowCount={setRowCount}
      pageSize={pageSize}
      setPageSize={setPageSize}
      handleEditLineSubmit={handleEditLineSubmit}
      searchInput={searchInput}
      changeSearchFilters={changeSearchFilters}
      handleChangeEditValue={handleChangeEditValue}
      handleSearchSubmit={handleSearchSubmit}
      selectedCategory={selectedCategory}
      handleDeleteRow={handleDeleteRow}
      onImportRows={onImportRows}
      toggleExpandRow={toggleExpandRow}
      lineNumbersToHighlight={lineNumbersToHighlight}
      editBlockValues={editBlockValues}
      setDeleteDialogIsOpen={setDeleteDialogIsOpen}
      loading={props.loading || initialLoad}
      setLoading={props.setLoading}
      selectionIds={selectionIds}
      setSelectionIds={setSelectionIds}
      expandedRowIds={expandedRowIds}
      setExpandedRowIds={setExpandedRowIds}
      viewCategoriesList={props.viewCategoriesList}
      isValidValue={isValidValue}
      addValue={addValue}
      setAddValue={setAddValue}
      handleAddLineSubmit={handleAddLineSubmit}
      isAddFormVisible={isAddFormVisible}
      setIsAddFormVisible={setIsAddFormVisible}
      />
    )}
      <input id="import_file" type="file" name="import_file" className='hidden'
      onInput={(e) => {
        const file = e.target.files[0];
        e.target.value = null;
        onImportRowsSubmit(file);
      }}
      />
    <Dialog open={deleteDialogIsOpen}
      onClose={() => { setSingleRowIdToDelete(null); setDeleteDialogIsOpen(false); setDeleteActionNote(""); }}
      PaperProps={{ className: 'bl-dialog-paper' }}
        >
        <div className='bl-dialog'>
          <div className='bl-dialog-header bl-dialog-header--danger'>
            <div className='bl-dialog-icon'>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
            </div>
            <h3 className='bl-dialog-title'>{selectionIds.length > 1 ? 'מחיקת רשומות' : 'מחיקת רשומה'}</h3>
            <button className='bl-dialog-close' onClick={() => { setSingleRowIdToDelete(null); setDeleteDialogIsOpen(false); setDeleteActionNote(""); }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
          <div className='bl-dialog-body'>
            <p className='cat-join-text'>{selectionIds.length > 1 ? 'האם אתם בטוחים שברצונכם להסיר את המספרים שנבחרו?' : 'האם אתם בטוחים שברצונכם להסיר את המספר מהרשימה?'}</p>
            <p className='cat-join-text cat-join-text--sub'>פעולה זו תסיר את המספר מרשימת החסימה של הקהילה.</p>
            <div className='bl-field'>
              <label htmlFor="cat-delete-actionnote">הערת ביצוע (אופציונלי)</label>
              <input id="cat-delete-actionnote" type="text" className='bl-input' value={deleteActionNote} placeholder="הסיבה למחיקה" onChange={(e) => setDeleteActionNote(e.target.value)} />
            </div>
          </div>
          <div className='bl-dialog-footer'>
            <button className='bl-dialog-cancel' onClick={() => { setSingleRowIdToDelete(null); setDeleteDialogIsOpen(false); setDeleteActionNote(""); }}>ביטול</button>
            <button className='bl-dialog-submit bl-dialog-submit--danger' onClick={() => { setDeleteDialogIsOpen(false); props.setLoading(true); handleDeleteRowsSubmit(); }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/></svg>
              הסר
            </button>
          </div>
        </div>
    </Dialog>

    <Dialog open={addDialogOpen} onClose={() => setAddDialogOpen(false)} PaperProps={{ className: 'bl-dialog-paper' }}>
      <div className='bl-dialog'>
        <div className='bl-dialog-header'>
          <div className='bl-dialog-icon'>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          </div>
          <h3 className='bl-dialog-title'>הוספת מספר לרשימה</h3>
          <button className='bl-dialog-close' onClick={() => setAddDialogOpen(false)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div className='bl-dialog-body'>
          <div className='bl-field'>
            <label htmlFor="cat-add-number">{t("Phone Number")}</label>
            <input id="cat-add-number" type="text" className='bl-input' dir="ltr" autoFocus
              value={addValue.number}
              placeholder={t("Phone Number")}
              onChange={(e) => { if (isValidValue(e.target.value, "number")) setAddValue({ ...addValue, number: e.target.value }); }}
              onKeyDown={(e) => { if (e.key === 'Enter') handleAddLineSubmit(); }}
            />
          </div>
          <BlockNumberNotes />
          <div className='bl-field-row'>
            <div className='bl-field'>
              <label htmlFor="cat-add-status">{t("Status")}</label>
              <select id="cat-add-status" value={addValue.status} onChange={(e) => setAddValue({ ...addValue, status: e.target.value })}>
                {allowedBlockStatuses().includes(STATUS_BLOCKED) && <option value={STATUS_BLOCKED}>{t("Blocked")}</option>}
                {allowedBlockStatuses().includes(STATUS_OPEN) && <option value={STATUS_OPEN}>{t("Open")}</option>}
              </select>
            </div>
            <div className='bl-field'>
              <label htmlFor="cat-add-calltype">{t("Call Type")}</label>
              <select id="cat-add-calltype" value={addValue.call_type} onChange={(e) => setAddValue({ ...addValue, call_type: e.target.value })}>
                {allowedBlockCallTypes().includes(CALL_TYPE_OUT) && <option value={CALL_TYPE_OUT}>{t("Outgoing call")}</option>}
                {allowedBlockCallTypes().includes(CALL_TYPE_IN) && <option value={CALL_TYPE_IN}>{t("Incoming call")}</option>}
                {allowedBlockCallTypes().includes(CALL_TYPE_ALL) && <option value={CALL_TYPE_ALL}>{t("Both")}</option>}
              </select>
            </div>
          </div>
          <div className='bl-field'>
            <label htmlFor="cat-add-note">{t("Note")}</label>
            <input id="cat-add-note" type="text" className='bl-input' value={addValue.note} placeholder={t("Note")} onChange={(e) => setAddValue({ ...addValue, note: e.target.value })} />
          </div>
          <div className='bl-field'>
            <label htmlFor="cat-add-actionnote">הערת ביצוע (אופציונלי)</label>
            <input id="cat-add-actionnote" type="text" className='bl-input' value={addValue.actionNote} placeholder="הסיבה להוספה" onChange={(e) => setAddValue({ ...addValue, actionNote: e.target.value })} />
          </div>
          <div className='bl-toggle-field' onClick={() => setAddValue({ ...addValue, active: addValue.active === "1" || addValue.active === 1 ? "0" : "1" })}>
            <span>{t("Is Active")}</span>
            <button type='button' role='switch' aria-checked={addValue.active === "1" || addValue.active === 1}
              className={'bl-switch' + (addValue.active === "1" || addValue.active === 1 ? ' on' : '')}
              onClick={(e) => { e.stopPropagation(); setAddValue({ ...addValue, active: addValue.active === "1" || addValue.active === 1 ? "0" : "1" }); }}>
              <span className='bl-switch-knob' />
            </button>
          </div>
        </div>
        <div className='bl-dialog-footer'>
          <button className='bl-dialog-cancel' onClick={() => setAddDialogOpen(false)}>ביטול</button>
          <button className='bl-dialog-submit' onClick={handleAddLineSubmit} disabled={!addValue.number}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            הוסף מספר
          </button>
        </div>
      </div>
    </Dialog>

    <Dialog open={!!editDialogRow} onClose={() => setEditDialogRow(null)} PaperProps={{ className: 'bl-dialog-paper' }}>
      {editDialogRow && (() => {
        const cur = { ...editDialogRow, ...(editBlockValues[editDialogRow.id] ?? {}) };
        const isActive = cur.active === 1 || cur.active === "1";
        return (
          <div className='bl-dialog'>
            <div className='bl-dialog-header'>
              <div className='bl-dialog-icon'>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
              </div>
              <h3 className='bl-dialog-title'>עריכת מספר</h3>
              <button className='bl-dialog-close' onClick={() => setEditDialogRow(null)}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div className='bl-dialog-body'>
              <div className='bl-field'>
                <label>{t("Phone Number")}</label>
                <input type="text" className='bl-input' dir="ltr" value={cur.number} disabled />
              </div>
              <div className='bl-field-row'>
                <div className='bl-field'>
                  <label>{t("Status")}</label>
                  <select value={cur.status} onChange={(e) => handleChangeEditValue(e.target.value, 'status', cur)}>
                    {(allowedBlockStatuses().includes(STATUS_BLOCKED) || cur.status === STATUS_BLOCKED) && <option value={STATUS_BLOCKED}>{t("Blocked")}</option>}
                    {(allowedBlockStatuses().includes(STATUS_OPEN) || cur.status === STATUS_OPEN) && <option value={STATUS_OPEN}>{t("Open")}</option>}
                  </select>
                </div>
                <div className='bl-field'>
                  <label>{t("Call Type")}</label>
                  <select value={cur.call_type} onChange={(e) => handleChangeEditValue(e.target.value, 'call_type', cur)}>
                    {(allowedBlockCallTypes().includes(CALL_TYPE_OUT) || cur.call_type === CALL_TYPE_OUT) && <option value={CALL_TYPE_OUT}>{t("Outgoing call")}</option>}
                    {(allowedBlockCallTypes().includes(CALL_TYPE_IN) || cur.call_type === CALL_TYPE_IN) && <option value={CALL_TYPE_IN}>{t("Incoming call")}</option>}
                    {(allowedBlockCallTypes().includes(CALL_TYPE_ALL) || cur.call_type === CALL_TYPE_ALL) && <option value={CALL_TYPE_ALL}>{t("Both")}</option>}
                  </select>
                </div>
              </div>
              <div className='bl-field'>
                <label>{t("Note")}</label>
                <input type="text" className='bl-input' value={cur.note ?? ''} placeholder={t("Note")} onChange={(e) => handleChangeEditValue(e.target.value, 'note', cur)} />
              </div>
              <div className='bl-field'>
                <label>הערת ביצוע (אופציונלי)</label>
                <input type="text" className='bl-input' value={cur.actionNote ?? ''} placeholder="הסיבה לשינוי" onChange={(e) => handleChangeEditValue(e.target.value, 'actionNote', cur)} />
              </div>
              <div className='bl-toggle-field' onClick={() => handleChangeEditValue(isActive ? 0 : 1, 'active', cur)}>
                <span>{t("Is Active")}</span>
                <button type='button' role='switch' aria-checked={isActive}
                  className={'bl-switch' + (isActive ? ' on' : '')}
                  onClick={(e) => { e.stopPropagation(); handleChangeEditValue(isActive ? 0 : 1, 'active', cur); }}>
                  <span className='bl-switch-knob' />
                </button>
              </div>
            </div>
            <div className='bl-dialog-footer'>
              <button className='bl-dialog-cancel' onClick={() => setEditDialogRow(null)}>ביטול</button>
              <button className='bl-dialog-submit' onClick={() => handleEditLineSubmit(editDialogRow.id)}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                שמירה
              </button>
            </div>
          </div>
        );
      })()}
    </Dialog>
    </>
  );
}
